/**
 * Asks the browser for a newer build. A worker being replaced makes update() reject («newestWorker is null» — report
 * #10, Farah, 2026-09-28, shown to her as «العملية ماتمتش» on تعديل شحنة): nothing the employee did, so it is dropped.
 *
 * Its own module so its test does not have to load SystemBanners (animations, the PWA register): that import alone
 * ran past vitest's 5 s on a busy run and made the test fail now and then.
 */
export function checkForUpdate(registration: Pick<ServiceWorkerRegistration, 'update'>): Promise<void> {
  return registration.update().then(() => undefined, () => undefined)
}
